import React, { Component } from 'react';
import { MemberRow as Row, CreditInput, MemberRowItem, SelectContainer } from './style';
import { ProfileAvatar } from '../../ProfileAvatar/ProfileAvatar';
import { config } from '../../../../Configurations';
import { TruncatedText } from '../../../UI/Text';
import { Icon } from '../../Icons/Icons';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import {
    convertDateToServerDateTypeMoment,
    parseToMoment,
    getFormattedDateFromMomentObject,
} from '../../../../Utils/timeConvertorHelper';
import { SelectItemComponent, CheckMark } from '../../Items/SelectItems/SelectItemComponent';
import { HoverableFadingContainer } from '../../HoverableFadingContainer';
import { Select } from '../../Select';
import { DatePickerComponent } from '../../Pickers/DatePicker';
import { getCredits, getAvailablePlans, getUserPlans, getPaidUntil } from './utils';
import { MemberPopup } from '../../Popups/MembersPopups';
import { MembersActionCreators } from '../../../../Store/ActionCreators/MembersActionCreators';
import { timeFormats } from '../../../../Constants/timeFormats';

const TEXT_HOVER_STYLE = 'font-weight: bold';
const TEXT_TRANSITION = 'all 0.25s ease-out';
const DATE_FORMAT = 'MMMM d, yyyy';

const statuses = {
    WAITING: 0,
    ACTIVE: 1,
    PENDING: 2,
    DISABLED: 3,
    OVERDUE: 4,
};

class MemberRow extends Component {
    getState = () => ({
        credits: getCredits(this.props.planMembers),
        id: this.props.id,
        status: this.props.status,
        plansAvailable: getAvailablePlans(this.props.plansAvailable),
        plansSelected: getUserPlans(this.props.planMembers),
        paidUntil: getPaidUntil(this.props.planMembers),
    });

    state = {
        ...this.getState(),
    };

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.setState(this.getState());
        }
    }

    handleChange = ({ target: { name, value } }) => {
        this.setState({ [name]: value }, () => {
            this.requestWithDelay();
        });
    };

    handleDateChange = date => {
        const { updateMembershipPlanForMember, id } = this.props;
        const { credits } = this.state;

        this.setState({ paidUntil: convertDateToServerDateTypeMoment(date) }, () => {
            updateMembershipPlanForMember(id, this.state.plansSelected.planMemberId, {
                credits,
                expires_at: this.state.paidUntil,
            });
        });
    };

    toggleSelect = e => {
        const { id, handleSelect, rowSelectOpen } = this.props;

        if (rowSelectOpen === id) handleSelect(null);
        else handleSelect(id);
    };

    toggleStatusClick = e => {
        const { id, handleStatusClick, rowStatusOpen } = this.props;

        if (rowStatusOpen === id) handleStatusClick(null);
        else {
            handleStatusClick(id);
            // this.setState({ clickPosition: e.target.getBoundingClientRect().left})
        }
    };

    selectItem = item => {
        const { id, handleSelect } = this.props;

        this.setState({ plansSelected: item }, () => {
            const ids = this.state.plansSelected.value;
            this.props.onMembershipTypeAdded(id, { plans: [ids] }, () => {
                this.setState(this.getState());
            });
            handleSelect(null);
        });
    };

    unselectItem = item => {
        const { plansSelected } = this.state;
        const { id } = this.props;

        const newArray = plansSelected.filter(plan => plan.value !== item.value);
        this.setState({ plansSelected: newArray }, () => {
            const ids = this.state.plansSelected.value;
            this.props.onMembershipTypeAdded(id, { plans: [ids] }, () => console.log('.'));
        });
    };

    deleteMember = id => {
        const { onDelete } = this.props;
        onDelete(id);
    };

    changeStatus = newStatus => {
        this.setState({ status: newStatus });
    };

    mapStatusToPopupAction = status => {
        const { resendInvitation, updateStatus, id } = this.props;
        switch (status) {
            case 1:
                return () =>
                    updateStatus(id, { status: statuses.DISABLED }, () => this.changeStatus(statuses.DISABLED));
            case 2:
                return () => resendInvitation(id);
            case 3:
                return () => updateStatus(id, { status: statuses.ACTIVE }, () => this.changeStatus(statuses.ACTIVE));
            case 4:
                return () =>
                    updateStatus(id, { status: statuses.DISABLED }, () => this.changeStatus(statuses.DISABLED));
            default:
                return () => {};
        }
    };

    requestWithDelay = debounce(() => {
        const {
            state: { credits, paidUntil },
            props: { id, updateMembershipPlanForMember },
        } = this;

        updateMembershipPlanForMember(id, this.state.plansSelected.planMemberId, {
            credits,
            expires_at: paidUntil,
        });
    }, 250);

    render() {
        const { user, id, rowSelectOpen, createdAt, closeAll, rowStatusOpen } = this.props;
        const { credits, plansAvailable, plansSelected, paidUntil, status } = this.state;
        const isSelectOpen = rowSelectOpen === id;
        const isStatusOpen = rowStatusOpen === id;
        const memberStatus = mapStatusToString(status);
        const statusColor = mapStatusToColor(status);
        const popupAction = this.mapStatusToPopupAction(status);

        return (
            <Row>
                <MemberRowItem width={'15%'}>
                    <ProfileAvatar size={'medium'} src={`${config.baseUrl}/${user.smallImage}`} />

                    <TruncatedText weight={'bold'} marginLeft={'20px'}>
                        {user.fullName}
                    </TruncatedText>
                </MemberRowItem>

                <MemberRowItem width={'10%'}>
                    <TruncatedText
                        cursor={'pointer'}
                        color={statusColor}
                        onClick={this.toggleStatusClick}
                        weight={100}
                        opacity={0.8}
                    >
                        {memberStatus}
                    </TruncatedText>

                    {isStatusOpen && <MemberPopup action={popupAction} onClose={closeAll} status={status} />}
                </MemberRowItem>

                <MemberRowItem width={'13%'}>
                    <TruncatedText opacity={0.8} weight={100}>
                        {user.email}
                    </TruncatedText>
                </MemberRowItem>

                <MemberRowItem width={'12%'}>
                    <TruncatedText opacity={0.8} weight={100}>
                        {user.mobile || 'No phone'}
                    </TruncatedText>
                </MemberRowItem>

                <MemberRowItem width={'15%'}>
                    <HoverableTruncatedText onClick={this.toggleSelect}>
                        {plansSelected.title || 'No plans selected'}
                    </HoverableTruncatedText>

                    {isSelectOpen && (
                        <Select
                            onClose={closeAll}
                            container={SelectContainer}
                            item={SelectItemComponent}
                            check={CheckMark}
                            onSelect={this.selectItem}
                            available={plansAvailable}
                            selected={plansSelected}
                        />
                    )}
                </MemberRowItem>

                <MemberRowItem width={'7%'}>
                    <CreditInput
                        type={'number'}
                        value={credits}
                        name={'credits'}
                        disabled={Object.keys(plansSelected).length === 0}
                        onChange={this.handleChange}
                    />
                </MemberRowItem>

                <MemberRowItem width={'13%'}>
                    {Object.keys(plansSelected).length === 0 ? (
                        <TruncatedText opacity={0.8} weight={100}>
                            None
                        </TruncatedText>
                    ) : (
                        <DatePickerComponent
                            dateFormat={DATE_FORMAT}
                            selected={paidUntil ? new Date(paidUntil) : null}
                            onChange={this.handleDateChange}
                            customInput={<CustomDateInput />}
                        />
                    )}
                </MemberRowItem>

                <MemberRowItem width={'10%'}>
                    <TruncatedText opacity={0.8} weight={100}>
                        {createdAt &&
                            getFormattedDateFromMomentObject(parseToMoment(createdAt, timeFormats.DAY_ORDER_MON_YEAR))}
                    </TruncatedText>
                </MemberRowItem>

                <MemberRowItem justify={'flex-end'} width={'5%'}>
                    <HoverableFadingContainer>
                        <Icon.Box onClick={() => this.deleteMember(id)} cursor={'pointer'} size={'24x24'}>
                            <Icon.Delete />
                        </Icon.Box>
                    </HoverableFadingContainer>
                </MemberRowItem>
            </Row>
        );
    }
}

const CustomDateInput = ({ onClick, value }) => (
    <HoverableTruncatedText onClick={onClick}>{value || 'Select a date'}</HoverableTruncatedText>
);

const HoverableTruncatedText = ({ children, ...props }) => (
    <TruncatedText
        cursor={'pointer'}
        hover={TEXT_HOVER_STYLE}
        transition={TEXT_TRANSITION}
        opacity={0.8}
        weight={100}
        {...props}
    >
        {children}
    </TruncatedText>
);

const mapStatusToString = status => {
    switch (status) {
        case 0:
            return 'Waiting...';
        case 1:
            return 'Active';
        case 2:
            return 'Pending...';
        case 3:
            return 'Disabled';
        case 4:
            return 'Overdue';
        default:
            return 'Waiting...';
    }
};

const mapStatusToColor = status => {
    switch (status) {
        case 0:
            return 'yellow';
        case 1:
            return 'white';
        case 2:
            return 'yellow';
        case 3:
            return 'darkGrey';
        case 4:
            return 'red';
        default:
            return 'white';
    }
};

const mapDispatchToProps = dispatch => ({
    updateCredits(id, data) {
        dispatch(MembersActionCreators.updateMemberRequest(id, data));
    },
    updateMembershipPlanForMember(memberId, memberPlanId, planData) {
        dispatch(MembersActionCreators.updateMembersMembershipPlanRequest(memberId, memberPlanId, planData));
    },
});

export default connect(
    null,
    mapDispatchToProps,
)(MemberRow);



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/MemberRow/index.js